(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('FileType', FileType);

    FileType.$inject = ['$resource'];

    function FileType ($resource) {
        var resourceUrl =  'api/file-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
